import { Navigate } from "react-router-dom";
import { usePatientAuthStore } from "@/stores/patientAuthStore";
import { CaregiverPatientsProvider } from "@/portals/caregiver/context/CaregiverPatientsContext";
import { PageSpinner } from "@/shared/components/spinner";
import { CaregiverLayout } from "./CaregiverLayout";

function SessionLoader() {
  return (
    <div className="bg-white">
      <PageSpinner fullScreen />
    </div>
  );
}

/**
 * Reuses the patient portal's auth session wholesale — there's no separate
 * caregiver identity yet (by design: this account is the same `users` row
 * whether it's viewing its own records or another patient's shared ones; see
 * app/modules/patient/models.py's UserRoleAssignment/CareRelationship split).
 * A genuinely separate caregiver portal/auth is future work once that module
 * gets its own build — this reuse is deliberately temporary scaffolding, not
 * the final architecture.
 */
export function CaregiverProtectedLayout() {
  const isAuthenticated = usePatientAuthStore((s) => s.isAuthenticated);
  const isLoading = usePatientAuthStore((s) => s.isLoading);

  if (isLoading) return <SessionLoader />;
  if (!isAuthenticated) return <Navigate to="/patient/auth/signin" replace />;

  return (
    <CaregiverPatientsProvider>
      <CaregiverLayout />
    </CaregiverPatientsProvider>
  );
}
